const NAME_NARROW_CHAR_LIMIT = 40

const truncateToNearestWholeWord = (
  name: string,
  limit: number = NAME_NARROW_CHAR_LIMIT
) => {
  const words = name.slice(0, limit).split(' ')

  return words.slice(0, words.length - 1).join(' ')
}

export const formatNameNarrow = (
  name: string,
  limit: number = NAME_NARROW_CHAR_LIMIT
) => {
  if (!name) return

  if (name.length < limit) {
    // eslint-disable-next-line consistent-return
    return name
  }

  const truncated = truncateToNearestWholeWord(name, limit)

  // eslint-disable-next-line consistent-return
  return `${truncated}...`
}
